<script>
import {
  pageMonCompteMesListesDeCoursesEmits,
  pageMonCompteMesListesDeCoursesProps,
  usePageMonCompteMesListesDeCourses
} from "./mixin";
import ListesDeCoursesSupprimer from "@/components/organisms/mon-compte/listes-de-courses/listes-de-courses-supprimer";
import ListeDeCoursesAjouterPanier from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-ajouter-panier/mobile";
import ListesDeCoursesCreer from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-creer";
import FormCheckBox from "@/components/molecules/form-checkbox";
import ListeDeCoursesOverview from "@/components/organisms/mon-compte/listes-de-courses/liste-de-courses-overview/mobile";
import StickyFooter from "@/components/molecules/sticky-footer";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import FormSelect from "@/components/molecules/form-select";
import StateOverlay from "@/components/molecules/state-overlay";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import Popin from "@/components/molecules/popin";

import illustrationProduitsCoeur from "@/assets/images/illustration-produits-coeur.svg";
import illustrationCrayonFeuille from "@/assets/images/illustration-crayon-feuille.svg";

export default {
  name: "ListesDeCoursesMobile",
  components: {
    ListesDeCoursesSupprimer,
    ListeDeCoursesAjouterPanier,
    ListesDeCoursesCreer,
    ListeDeCoursesOverview,
    FormCheckBox,
    StickyFooter,
    Button,
    Card,
    FormSelect,
    StateOverlay,
    LazyImage,
    Titre,
    Popin
  },
  emits: [...pageMonCompteMesListesDeCoursesEmits()],
  props: {
    ...pageMonCompteMesListesDeCoursesProps()
  },
  setup(props, context) {
    const supprimer = ref(null);
    const creer = ref(null);
    const ajouter = ref(null);
    const {
      isLoading,
      listeSelected,
      listesSelected,
      listesToDelete,
      createListeError,
      createListeState,
      toggleSelectList,
      isSelected,
      selectAll,
      unselectAll,
      deleteListes,
      deleteListe,
      confirmDeleteListes,
      openCreateListe,
      createListe,
      addToCartListe,
      confirmAddToCartListe,
      addToCartListes,
      mounted
    } = usePageMonCompteMesListesDeCourses(
      props,
      context,
      supprimer,
      creer,
      ajouter
    );

    onMounted(mounted);

    return {
      isLoading,
      listeSelected,
      listesSelected,
      listesToDelete,
      createListeError,
      createListeState,
      toggleSelectList,
      isSelected,
      selectAll,
      unselectAll,
      deleteListes,
      deleteListe,
      confirmDeleteListes,
      openCreateListe,
      createListe,
      addToCartListe,
      confirmAddToCartListe,
      addToCartListes,
      illustrationProduitsCoeur,
      illustrationCrayonFeuille,
      creer,
      ajouter,
      supprimer
    };
  },
  data() {
    return {
      action: "addToCartListes"
    };
  },
  methods: {
    footerAction() {
      if (this.action === "addToCartListes") {
        this.addToCartListes();
      } else {
        this.deleteListes();
      }
    }
  }
};
</script>

<template>
  <StateOverlay
    overlay
    class="u-p-sm"
    :is-loading="isLoading"
  >
    <ListesDeCoursesSupprimer
      ref="supprimer"
      slide-up
      :is-loading="isLoading"
      :listes-to-delete="listesToDelete"
      @confirmDelete="confirmDeleteListes"
    />
    <ListesDeCoursesCreer
      ref="creer"
      slide-up
      :is-loading="isLoading"
      :state="createListeState"
      :error="createListeError"
      @create="createListe"
    />
    <Popin
      ref="ajouter"
      aria-label="Ajouter la liste au panier"
      size="lg"
      slide-up
    >
      <ListeDeCoursesAjouterPanier
        class="u-p-md"
        :liste="listeSelected"
        @addListe="confirmAddToCartListe"
      />
    </Popin>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-sm"
    >
      Mes listes de courses
    </Titre>

    <template v-if="listesDeCourse.length == 0 && !isLoading">
      <Card
        elevation="sm"
        class="u-text-center u-p-md"
      >
        <LazyImage
          :src="illustrationCrayonFeuille"
          class="u-inline-block u-mb-sm"
          width="77"
          height="60"
        />
        <Titre
          tag="h2"
          size="sm"
          class="u-mb-sm"
        >
          Vous n'avez pas encore de liste
        </Titre>
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="openCreateListe"
        >
          Je crée ma première liste
        </Button>
      </Card>
    </template>
    <template v-else>
      <Button
        variant="primary"
        radius="full"
        size="md"
        class="u-mb-md"
        @click="openCreateListe"
      >
        Je crée une nouvelle liste
      </Button>
      <Card
        v-for="liste in listesDeCourse"
        :key="liste.id"
        :variant="isSelected(liste.id) ? 'primary-lighter' : 'grey-5'"
        radius="md"
        class="u-mb-md"
      >
        <FormCheckBox
          class="u-p-sm"
          :value="isSelected(liste.id)"
          @change="toggleSelectList($event, liste)"
        >
          <template v-if="isSelected(liste.id)">
            Désélectionner
          </template>
          <template v-else>
            Sélectionner
          </template>
          cette liste
        </FormCheckBox>
        <ListeDeCoursesOverview
          :liste="liste"
          @delete="deleteListe"
          @addToCart="addToCartListe"
        />
      </Card>
    </template>

    <div class="u-mt-lg u-p-sm">
      <Titre
        tag="h2"
        size="md"
        variant="primary"
        class="u-mb-sm u-text-center"
      >
        N'oubliez pas vos produits habituels
      </Titre>
      <div class="u-flex u-flex-align-center">
        <LazyImage
          :src="illustrationProduitsCoeur"
          class="u-flex-item-none"
          width="85"
          height="59"
        />
        <div class="u-ml-sm">
          <p>
            Vous avez déjà commandé chez Cora ? Retrouvez les produits que vous achetez le plus souvent dans votre liste de produits habituels !
          </p>
        </div>
      </div>
      <div class="u-text-center u-mt-lg">
        <Button
          variant="primary"
          radius="full"
          size="sm"
          class="u-flex-item-none"
          to="/mon-compte/mes-produits-habituels"
        >
          Voir mes produits habituels
        </Button>
      </div>
    </div>

    <StickyFooter v-if="listesSelected.length > 0">
      <div>
        <template v-if="listesSelected.length === listesDeCourse.length">
          <Button
            link
            variant="text-light"
            class="u-mb-sm"
            @click="unselectAll"
          >
            Tout désélectionner
          </Button>
        </template>
        <template v-else>
          <Button
            link
            variant="text-light"
            class="u-mb-sm"
            @click="selectAll"
          >
            Tout sélectionner
          </Button>
        </template>

        <div class="u-flex u-mb-sm">
          <FormSelect
            ref="actionSelector"
            v-model="action"
            title="Action"
            :options="[{ value: 'addToCartListes', text: 'Ajouter au panier les listes sélectionnées' }, { value: 'deleteListes', text: 'Supprimer les listes sélectionnées' }]"
          />
          <Button
            variant="primary"
            radius="full"
            size="md"
            class="u-ml-xs"
            @click="footerAction"
          >
            OK
          </Button>
        </div>
      </div>
    </StickyFooter>
  </StateOverlay>
</template>

<style lang="scss" scoped>
</style>
